import React, { useState, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import GoogleMapMarker from './GoogleMapMarker';
import { connect } from 'react-redux';
import { setCoords } from './../Actions/Booking.action';
import constants from '../constants';
import useSupercluster from "use-supercluster";

const Marker = ({ children }) => children;

const BookingMap = props => {
  const { filteredStores, coords } = props;

  const [bounds, setBounds] = useState(null);
  const [zoom, setZoom] = useState(10);

  const [mapReference, setMapReference] = useState(null);
  const [mapsReference, setMapsReference] = useState(null);
  const onGoogleApiLoaded = ({ map, maps }) => {
    setMapReference(map);
    setMapsReference(maps);
  };

  useEffect(() => {
    if (mapReference) {
      mapReference.setZoom(14);
      mapReference.panTo({ lat: coords.lat, lng: coords.lng });
      const mapDivWidth = mapReference.getDiv().offsetWidth;
      if (mapDivWidth > 700) {
        mapReference.panBy(-300, 0);
      }
    }
  }, [coords, mapReference]);

  const points = filteredStores.map(store => ({
    type: "Feature",
    properties: { cluster: false, storeItemId: store.itemId, storeIndex: store.index },
    geometry: {
      type: "Point",
      coordinates: [parseFloat(store.lng), parseFloat(store.lat)]
    }
  }));

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: { radius: 60, maxZoom: 9 }
  });

  return (
    <>
      <GoogleMapReact
        bootstrapURLKeys={{ key: constants.googleMapApiKey }}
        defaultCenter={coords}
        yesIWantToUseGoogleMapApiInternals={true}
        defaultZoom={9}
        onGoogleApiLoaded={onGoogleApiLoaded}
        onChange={({ zoom, bounds }) => {
          setZoom(zoom);
          setBounds([bounds.nw.lng, bounds.se.lat, bounds.se.lng, bounds.nw.lat]);
        }}
      >
        {clusters.map((cluster, index) => {
          const [longitude, latitude] = cluster.geometry.coordinates;
          const {
            cluster: isCluster,
            point_count: pointCount
          } = cluster.properties;
          if (isCluster) {
            return (
              <Marker
                key={`cluster-${index}`}
                lat={latitude}
                lng={longitude}
              >
                <div
                  className="cluster-map-marker"
                  style={{
                    width: `${32 + (pointCount / points.length) * 50}px`,
                    height: `${32 + (pointCount / points.length) * 50}px`
                  }}
                  onClick={() => {
                    mapReference.setZoom(supercluster.getClusterExpansionZoom(cluster.id));
                    mapReference.panTo({ lat: latitude, lng: longitude });
                    const mapDivWidth = mapReference.getDiv().offsetWidth;
                    if (mapDivWidth > 700) {
                      mapReference.panBy(-300, 0);
                    }
                  }}
                >
                  {pointCount}
                </div>
              </Marker>
            );
          } else {
            return (
              <Marker
                key={index}
                lat={latitude}
                lng={longitude}
              >
                <GoogleMapMarker
                  selectedIndex={props.index}
                  index={cluster.properties.storeIndex}
                />
              </Marker>
            );
          }
        })}
      </GoogleMapReact>
    </>);
}
const mapStateToProps = ({ booking: { coords, stores, filteredStores, index, filterString } }) => ({ coords, filteredStores, stores, index, filterString });

const mapDispatchToProps = dispatch => ({
  setCoords: (coords) => dispatch(setCoords(coords)),
});
export default connect(mapStateToProps, mapDispatchToProps)(BookingMap);